




























import Vue from "vue";
import { IInviteeInfo } from "@/types";
import { action, store } from "../../services/store";
import { cutImage } from "@/utils/img";
import { insertCss } from "@/utils/loadScript";
import { formatDuration } from "@/utils/format";

export default Vue.extend({
  data() {
    return {
      countdown: 0,
      timer: NaN
    };
  },
  computed: {
    // 任务结束时间
    coolDown(): number {
      return store.taskInfo.cool_down;
    },
    // 总共要邀请的人数
    totalNum(): number {
      return store.taskInfo.total_num;
    },
    // 已经邀请的人数
    invitedNum(): number {
      return store.taskInfo.invited_num;
    },
    // 已经邀请的人的信息
    inviteeList(): IInviteeInfo[] {
      let invitees = store.taskInfo.invitee_info;
      if (!invitees) {
        return new Array(3).fill({
          name: "",
          face: "",
          mid: 0
        });
      }
      const len = invitees.length;
      if (len < 3) {
        const fillLength = 3 - len;
        invitees = invitees.concat(new Array(fillLength).fill({
          name: "",
          face: "",
          mid: 0
        }));
      }
      return invitees;
    },
    countdownStr(): string {
      return formatDuration(this.countdown);
    }
  },
  methods: {
    share() {
      this.$emit("share");
    },
    cutImage(url: string, width: number): string {
      return cutImage(url, width);
    },
    setAnimation(
      name: string,
      totalNum: number,
      colNum: number,
      imgWidth: number,
      imgHeight: number
    ) {
      let ht = "";
      const step = 100 / totalNum;
      for (let i = 0; i < totalNum; i ++) {
        const row = Math.floor(i / colNum);
        const col = i % colNum;
        ht += `
          ${step * i}% {
            background-position: -${imgWidth * col}px -${imgHeight * row}px;
          }
        `;
      }
      const keyframes = `
        @keyframes ${name} {
          ${ht}
        }
      `;
      console.log(keyframes);
      insertCss(keyframes);
    }
  },
  watch: {
    coolDown: {
      handler(val) {
        // 计算倒计时
        if (val) {
          this.countdown = val;
          clearInterval(this.timer);
          // @ts-ignore
          this.timer = setInterval(() => {
            this.countdown--;
            if (this.countdown <= 0) {
              // 倒计时结束，刷新页面
              clearInterval(this.timer);
              action.updateTaskInfo();
              action.updatePrizes();
            }
          }, 1000);
        }
      },
      immediate: true
    }
  }
});
